import type { ITransformer } from 'mobx-utils';
import { createTransformer } from 'mobx-utils';

import { bind } from 'bind-decorator';
import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import type { GroupResponse } from '../../api.dtos';

class GroupsStore extends CacheStore<GroupResponse> {
  constructor() {
    super('groups');
  }

  readonly ByLocation: ITransformer<number, GroupResponse[]> = createTransformer(this._ByLocation);

  public search(searchTerm: string = ''): GroupResponse[] {
    const lowerSearchTerm = searchTerm.toLowerCase();
    return this.Current.filter(
      (biz) =>
        biz?.name?.toLowerCase().includes(lowerSearchTerm) ||
        biz?.locationName?.toLowerCase().includes(lowerSearchTerm)
    );
  }

  @computed
  get Current(): GroupResponse[] {
    return this.All.filter((x) => x.showReferrals);
  }

  @computed
  get Healthcode(): GroupResponse[] {
    return this.Current.filter((x) => x.healthcodeEnabled);
  }

  @bind
  private _ByLocation(locationId: number): GroupResponse[] {
    return this.All.filter((x) => {
      return x.locationIds.includes(locationId);
    });
  }
}

export default GroupsStore;
